import { useQuery } from "@tanstack/react-query";
import { axios } from "lib/axios";

export const getTeamAnalytics = ({ churchId }) => {
  return axios.get(`/churches/${churchId}/dashboard/team-analytics`);
};

export const useTeamAnalytics = ({ churchId, config } = {}) => {
  return useQuery({
    ...config,
    queryKey: ["team-analytics", churchId],
    queryFn: () => getTeamAnalytics({ churchId }),
    select: response => response.result,
    refetchOnMount: true,
    refetchOnReconnect: true,
    refetchOnWindowFocus: true,
    staleTime: 0,
    cacheTime: 0
  });
};
